import { parseISO, isValid } from 'date-fns';
import { toZonedTime, fromZonedTime, formatInTimeZone } from "date-fns-tz";

const BUSINESS_TIMEZONE = 'Australia/Sydney';

export const formatDateToSydneyTimeZone = (date, formatString = 'dd/MM/yyyy') => {
  if (!date) return '';

  const dateObj = date instanceof Date ? date : parseISO(date);

  if (!isValid(dateObj)) return '';

  return formatInTimeZone(dateObj, BUSINESS_TIMEZONE, formatString);
};

export const getSydneyDateObject = (input) => {
  return toZonedTime(input, BUSINESS_TIMEZONE)
};

export const buildSydneyDateTime = (date, hours, minutes) => {
  const datePart = formatDateToSydneyTimeZone(date, 'yyyy-MM-dd');
  return fromZonedTime(
    `${datePart} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`,
    BUSINESS_TIMEZONE
  );
};

export const toApiDateTime = (input) => {
  if (!input) return '';

  // Case 1: Date object or full datetime string
  if (input instanceof Date || (typeof input === 'string' && input.includes('T'))) {
    const dateObj = input instanceof Date ? input : parseISO(input);

    if (!isValid(dateObj)) return '';

    return dateObj.toISOString();
  }

  // Case 2: date-only string (yyyy-MM-dd) — treat as Sydney midnight
  if (typeof input === 'string') {
    const utcDate = fromZonedTime(
      `${input} 00:00:00`,
      BUSINESS_TIMEZONE
    );

    if (!isValid(utcDate)) return '';

    return utcDate.toISOString();
  }

  return '';
};
